import type { Locale } from "@/catalog";
import type { UnlockReceiptData } from "@/unlock-receipt";

import "./UnlockReceipt.css";

interface UnlockReceiptProps {
  locale: Locale;
  receipt: UnlockReceiptData;
}

function formatReceiptMoney(minorAmount: number, currency: string, locale: Locale): string {
  const formatter = new Intl.NumberFormat(locale === "pt" ? "pt-BR" : "en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
  });
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits ?? 2;
  return formatter.format(minorAmount / (10 ** fractionDigits));
}

export default function UnlockReceipt({ locale, receipt }: UnlockReceiptProps) {
  const basePaid = formatReceiptMoney(
    receipt.paidAmountCents,
    receipt.paidCurrency,
    locale,
  );
  const presented = receipt.presentmentAmount !== null && receipt.presentmentCurrency
    ? formatReceiptMoney(receipt.presentmentAmount, receipt.presentmentCurrency, locale)
    : null;
  const paid = presented ?? basePaid;
  const next =
    receipt.nextPriceCents !== null && receipt.nextPriceCurrency
      ? formatReceiptMoney(receipt.nextPriceCents, receipt.nextPriceCurrency, locale)
      : null;

  return (
    <section
      className="unlock-receipt"
      aria-label={locale === "pt" ? "Recibo do desbloqueio" : "Unlock receipt"}
    >
      <span className="unlock-receipt__seal" aria-hidden="true">
        #{receipt.buyerPosition}
      </span>
      <p>
        {locale === "pt" ? (
          <>
            Você entrou como <strong>#{receipt.buyerPosition}</strong> por <strong>{paid}</strong>;
            {presented && <> preço-base <strong>{basePaid}</strong>;</>}
            {" "}próximo preço <strong>{next ?? "atualizando"}</strong>.
          </>
        ) : (
          <>
            You joined as <strong>#{receipt.buyerPosition}</strong> for <strong>{paid}</strong>;
            {presented && <> base price <strong>{basePaid}</strong>;</>}
            {" "}next price <strong>{next ?? "updating"}</strong>.
          </>
        )}
      </p>
    </section>
  );
}
